import { DOCUMENT_ORIGIN } from './consts'

export const post = async (url, data) => {
  let formData = new FormData()
  formData.append('type', 'user')

  Object.keys(data).forEach((key) => formData.append(key, data[key]))
  const response = await fetch(url, {
    method: 'POST',
    body: formData,
  })
  try {
    return await response.json()
  } catch (error) {
    console.error('Request failed:', error)
    throw error
  }
}
export const get = async (url, token) => {
  const response = await fetch(url, {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  })
  try {
    return await response.json()
  } catch (error) {
    console.error('Request failed:', error)
    throw error
  }
}
export const obtainToken = async () => {
  const url = `${DOCUMENT_ORIGIN}/rpc/token?method=obtain_auth_token`
  console.debug('Requesting token from:', url)
  const response = await fetch(url, { credentials: 'include' })

  if (!response.ok) return null
  return response.json()
}

export const bindUserSession = async (token) => {
  const url = `${DOCUMENT_ORIGIN}/rpc/token?method=bind_session_token&auth_token=${token}`

  try {
    const response = await fetch(url, { credentials: 'include' })

    if (!response.ok) {
      console.error(
        'Failed to bind user session with status:',
        response.statusText
      )
      return false
    }

    const responseData = await response.json()

    return responseData
  } catch (error) {
    console.error('Failed to bind user session:', error)
    return false
  }
}
